// null を指定された値に変換する
export function convertNullObject(
  obj: any,
  convValue: any,
  targetKeys: string[]
): any {
  targetKeys.forEach(key => {
    if (obj[key] === null) {
      obj[key] = convValue;
    }
  });
  return obj;
}
